import type { CreateUpdateFavoriteModel, FavoriteItemModel, UpdateFavorite, UpdateFavoritesStatusModel } from './model/favoriteModel'
import Net from '@/services/net'

export function createUpdateFavorite(catalogCode: number, requestObject: CreateUpdateFavoriteModel) {
  return Net.t1.put<FavoriteItemModel>(`/catalogs/${catalogCode}/favorites/createupdate`, requestObject)
}

export function updateFavoritesStatus(catalogCode: number, requestObject: UpdateFavoritesStatusModel[]) {
  return Net.t1.put(`/catalogs/${catalogCode}/favorites/status`, requestObject)
}

export function updateFavorite(catalogCode: number, favId: number, requestObject: UpdateFavorite) {
  return Net.t1.put(`/catalogs/${catalogCode}/favorites/${favId}`, requestObject)
}

export function shareFavorites(catalogCode: number, favIds: number[], userIds: number[], userGroupIds: number[]) {
  return Net.t1.put(`/catalogs/${catalogCode}/favorites/share`, {
    FavoriteIds: favIds,
    UserIds: userIds,
    AccountGroupIds: userGroupIds,
  })
}
